var Update_Variations = {
	init:function(){
		Debug.log("Update_Variations init");
		
		var _form = document.getElementsByClassName("variations_form")[0];
				
		$('.variations_form').find("select").on("change", function(){
			Debug.log("SELECT CHANGED");
			
			_form.dispatchEvent(new Event('check_variations'));
		})
	}
}

$(window).load(function(){
	if($('.variations_form').length){
		Update_Variations.init();
	}
})
